export const VAT_RATE_2025 = 0.15;
export const VAT_RATE_2026 = 0.155;

export function getVatRate(purchaseOrderDate?: Date | string): number {
  const date = purchaseOrderDate ? new Date(purchaseOrderDate) : undefined;
  const year = date?.getFullYear();
  if (year === 2026) return VAT_RATE_2026;
  return VAT_RATE_2025;
}
